import i18n from '../../i18n.js';
import queryString from 'query-string';
import {sample} from 'effector';
import {
    $applicationCategories,
    $applicationInfo,
    $applications,
    $applicationsTable,
    $selectedApplication
} from './stores.js';
import {
    downloadAppFileFx,
    getAppCategoriesFx,
    getApplicationByIdFx,
    getApplicationsFx, getMyApplicationsFx,
    updateApplicationFx
} from './effects.js';
import {
    ApplicationsGate, downloadAppFileEv, resetApplicationEv,
    selectApplicationEv,
    setApplicationsTableEv, submitAppUpdateEv
} from './events.js';
import {showSuccessEv} from '../infoModel/index.js';
import {$user} from '../authModel/index.js';


$applications.on([getApplicationsFx.doneData, getMyApplicationsFx.doneData], (state, payload) => ({data: payload.results, count: payload.count}))
    .reset(ApplicationsGate.close)

$selectedApplication.on(selectApplicationEv, (_, id) => id)
    .reset(resetApplicationEv)

$applicationInfo.on(getApplicationByIdFx.doneData, (state, payload) => payload)
    .reset(resetApplicationEv)

$applicationsTable.on(setApplicationsTableEv, (state, payload) => ({...state, ...payload}))
    .reset(ApplicationsGate.close)

$applicationCategories.on(getAppCategoriesFx.doneData, (state, payload) => payload)
    .reset(ApplicationsGate.close)

sample({
    source: {table: $applicationsTable, gate: ApplicationsGate.state},
    clock: [ApplicationsGate.state.updates, $applicationsTable.updates, updateApplicationFx.doneData],
    filter: ({gate}) => Object.hasOwn(gate, 'type') && gate?.type !== 'my',
    fn: ({gate, table}) => {
        let search = {}
        if (gate.search?.size > 0) {
            search = Object.fromEntries(gate.search.entries())
        }
        for (const [key, value] of Object.entries(search)) {
            if (!value || value === '' || value === 'null') {
                delete search[key]
            }
        }

        return queryString.stringify(
            {
                type: gate.type,
                limit: table.limit,
                offset: table.offset,
                ...search
            },
            {skipEmptyString: true, skipNull: true}
        )
    },
    target: getApplicationsFx
})

sample({
    source: {table: $applicationsTable, gate: ApplicationsGate.state, user: $user},
    clock: [ApplicationsGate.state.updates, $applicationsTable.updates, updateApplicationFx.doneData],
    filter: ({gate, user}) => Object.hasOwn(gate, 'type') && gate?.type === 'my' && !!user.gov_id,
    fn: ({gate, table, user}) => {
        let search = {}
        if (gate.search?.size > 0) {
            search = Object.fromEntries(gate.search.entries())
        }
        for (const [key, value] of Object.entries(search)) {
            if (!value || value === '' || value === 'null') {
                delete search[key]
            }
        }

        return queryString.stringify(
            {
                // bin: user.gov_id,
                limit: table.limit,
                offset: table.offset,
                ...search
            },
            {skipEmptyString: true, skipNull: true}
        )
    },
    target: getMyApplicationsFx
})

sample({
    clock: selectApplicationEv,
    filter: id => !!id,
    fn: id => id,
    target: getApplicationByIdFx
})

sample({
    source: $applicationInfo,
    clock: submitAppUpdateEv,
    fn: (app, data) => ({id: app.id, data: {providerComment: data.provider_comment, status: data.type}}),
    target: updateApplicationFx
})

sample({
    clock: updateApplicationFx.doneData,
    fn: () => ({summary: i18n.t('Успешно'), detail: i18n.t('Изменения сохранены')}),
    target: [showSuccessEv, resetApplicationEv]
})

sample({
    clock: ApplicationsGate.open,
    target: getAppCategoriesFx
})

sample({
    clock: downloadAppFileEv,
    target: downloadAppFileFx
})